export enum StoreAssetRequestVisibility {
    Public = 'public',
    Private = 'private',
}